import React from 'react';
import Spinner from '@salesforce/design-system-react/components/spinner';

export default function CQSpinner() {

    const spinnerStyles = {
        width: '20px', 
        display: 'inline-block', 
        height: '20px', 
        zIndex: '2' 
    };
    
    return <>
        <span className="slds-is-relative" style={spinnerStyles}>
            <Spinner
                size="small"
                variant="base"
                hasContainer={false}
                assistiveText={{ label: 'Main Frame Loading...' }}
            />
        </span>
    </>
}
